import { ActivityReservationStatusFilter } from "Services/API/API";

export const NOT_DELETED_FILTER = ActivityReservationStatusFilter.Active
   | ActivityReservationStatusFilter.CancellationPolicy
   | ActivityReservationStatusFilter.Completed
   | ActivityReservationStatusFilter.Future;